import React, { useState } from 'react';
import {
    Container,
    Paper,
    Typography,
    TextField,
    Button,
    Box,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { SetPointCreate } from '../../Conections/AcademicConection';


function PointCreate() {

    const goTo = useNavigate();
    const { getToken, getCompany } = useAuth();
    const params = useParams();

    const [nombre, setNombre] = useState('');
    const [peso, setPeso] = useState('');
    const [error, setError] = useState('');

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/createpoint/:activity");
                if (permisionCan === 0) {
                    goTo("/dashboard");
                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [getCompany, getToken, goTo]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!nombre.trim() || !peso.trim()) {
            setError('Por favor, complete todos los campos.');
            return;
        }
        if (isNaN(peso) || Number(peso) <= 0) {
            setError('El peso debe ser un número positivo.');
            return;
        }
        const datos = await SetPointCreate(
            getToken(),
            getCompany(),
            params["activity"],
            nombre,
            peso
        );
        goTo("/academic/showactivity/" + datos);
    };

    return (
        <Container component="main" maxWidth="sm">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography component="h1" variant="h5" align="center" gutterBottom>
                    Crear Nuevo Punto
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="nombre"
                        label="Nombre del Punto"
                        name="nombre"
                        autoFocus
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="peso"
                        label="Peso del Punto"
                        type="number"
                        id="peso"
                        value={peso}
                        onChange={(e) => setPeso(e.target.value)}
                        inputProps={{ min: "0", step: "0.1" }}
                    />
                    {error && (
                        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                            {error}
                        </Typography>
                    )}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Crear Punto
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}

export default PointCreate;

